/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

type Parsed = {
    isValid: boolean;
    errorText: string | null;
    formattedValue: string | null;
};

export function matchPasswordValidator(passwordToMatch: string) {
    return (value: string) => {
        const parsed: Parsed = {
            isValid: false,
            errorText: null,
            formattedValue: null,
        };

        if (passwordToMatch !== value) {
            parsed.errorText = 'Passwords do not match';
            return parsed;
        }

        parsed.isValid = true;
        parsed.formattedValue = value;
        return parsed;
    };
}
